/* stylelint-disable selector-no-qualifying-type */
/* stylelint-disable property-no-vendor-prefix */

/*
* @prop --uic-scrollpanel-background-color: The background color of the entire scroll panel.
* @prop --uic-scrollpanel-indicator-color: The color of the line indicating the track.
* @prop --uic-scrollpanel-track-width: The width of the the track.
* @prop --uic-scrollpanel-track-spacing: The margin on each side of the track. Affects the interactable area.
* @prop --uic-scrollpanel-bar-color: The color of the bar inside the track.
*/

uic-scrollpanel {
    display: block;
    background-color: var(--uic-scrollpanel-background-color);
    overflow-x: hidden;

    .track-indicator {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 50%;
        width: 1px;
        background: var(--uic-scrollpanel-indicator-color);
    }

    // ADJUSTMENTS TO SIMPLEBAR CSS

    .simplebar-track {
        opacity: 0;
        transition: opacity 0.2s 1s linear;
    }

    &.uic-scrollpanel--scrollbar-auto-hide-disabled .simplebar-track {
        opacity: 1;
        transition: none;
    }

    .simplebar-track.simplebar-vertical {
        width: calc(
            var(--uic-scrollpanel-track-width) + 2 *
                var(--uic-scrollpanel-track-spacing)
        );
        top: calc(var(--uic-scrollpanel-track-spacing) + 8px);
        bottom: calc(var(--uic-scrollpanel-track-spacing) + 8px);
        right: 0;
        overflow: visible;
        pointer-events: visible;

        &::before {
            content: "";
            position: absolute;
            top: -8px;
            bottom: -8px;
            left: var(--uic-scrollpanel-track-spacing);
            right: var(--uic-scrollpanel-track-spacing);
            box-shadow: 0 0 6px 0 var(--uic-color-blue6a20);
            background-color: var(--uic-color-white);
        }
    }

    .simplebar-scrollbar {
        cursor: pointer;
    }

    .simplebar-scrollbar::before {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        left: calc(50% - 1px);
        width: 2px;
        background: var(--uic-scrollpanel-bar-color);
    }

    .simplebar-track.simplebar-horizontal .simplebar-scrollbar {
        right: auto;
        left: 0;
        top: 0;
        bottom: 0;
        min-height: 0;
        min-width: 10px;
        width: auto;
    }

    .simplebar-track {
        z-index: 1;
        position: absolute;
        right: 0;
        bottom: 0;
        pointer-events: none;
        overflow: hidden;
    }

    &[data-simplebar].simplebar-dragging .simplebar-track {
        pointer-events: all;
    }

    .simplebar-scrollbar {
        position: absolute;
        left: 0;
        right: 0;
        min-height: 10px;
    }

    &.simplebar-scrolling .simplebar-track,
    &.simplebar-hover .simplebar-track,
    &.simplebar-mouse-entered .simplebar-track {
        opacity: 1;
        transition-delay: 0s;
        transition-duration: 0s;
    }

    .simplebar-track:hover {
        /* When hovered, remove all transitions from drag handle */
        opacity: 1;
        transition-delay: 0s;
        transition-duration: 0s;
    }

    /* Rtl support */
    &[data-simplebar-direction="rtl"] .simplebar-track.simplebar-vertical {
        right: auto;
        left: 0;
    }
}

// SIMPLEBAR CSS

[data-simplebar] {
    position: relative;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-content: flex-start;
    align-items: flex-start;
}

.simplebar-wrapper {
    overflow: hidden;
    width: inherit;
    height: inherit;
    max-width: inherit;
    max-height: inherit;
}

.simplebar-mask {
    direction: inherit;
    position: absolute;
    overflow: hidden;
    padding: 0;
    margin: 0;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    width: auto !important;
    height: auto !important;
    z-index: 0;
}

.simplebar-offset {
    direction: inherit !important;
    box-sizing: inherit !important;
    resize: none !important;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    padding: 0;
    margin: 0;
    -webkit-overflow-scrolling: touch;
}

.simplebar-content-wrapper {
    direction: inherit;
    box-sizing: border-box !important;
    position: relative;
    display: block;
    height: 100%; /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */
    width: auto;
    max-width: 100%; /* Not required for horizontal scroll to trigger */
    max-height: 100%; /* Needed for vertical scroll to trigger */
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.simplebar-content-wrapper::-webkit-scrollbar,
.simplebar-hide-scrollbar::-webkit-scrollbar {
    width: 0;
    height: 0;
}

.simplebar-content::before,
.simplebar-content::after {
    content: " ";
    display: table;
}

.simplebar-placeholder {
    max-height: 100%;
    max-width: 100%;
    width: 100%;
    pointer-events: none;
}

.simplebar-height-auto-observer-wrapper {
    box-sizing: inherit !important;
    height: 100%;
    width: 100%;
    max-width: 1px;
    position: relative;
    float: left;
    max-height: 1px;
    overflow: hidden;
    z-index: -1;
    padding: 0;
    margin: 0;
    pointer-events: none;
    flex-grow: inherit;
    flex-shrink: 0;
    flex-basis: 0;
}

.simplebar-height-auto-observer {
    box-sizing: inherit;
    display: block;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    height: 1000%;
    width: 1000%;
    min-height: 1px;
    min-width: 1px;
    overflow: hidden;
    pointer-events: none;
    z-index: -1;
}

[data-simplebar].simplebar-dragging .simplebar-content {
    pointer-events: none;
    user-select: none;
    -webkit-user-select: none;
}

.simplebar-track.simplebar-horizontal {
    left: 0;
    height: 11px;
}

.simplebar-dummy-scrollbar-size {
    direction: rtl;
    position: fixed;
    opacity: 0;
    visibility: hidden;
    height: 500px;
    width: 500px;
    overflow-y: hidden;
    overflow-x: scroll;
    -ms-overflow-style: scrollbar !important;
}

.simplebar-dummy-scrollbar-size > div {
    width: 200%;
    height: 200%;
    margin: 10px 0;
}

.simplebar-hide-scrollbar {
    position: fixed;
    left: 0;
    visibility: hidden;
    overflow-y: scroll;
    scrollbar-width: none;
    -ms-overflow-style: none;
}
